{
  " (Shiprocket recommends)": " (Shiprocket ची शिफारस)",
  " (test)": " (चाचणी)",
  " Next you will set up Google Authenticator.": " पुढे तुम्ही Google Authenticator सेट कराल.",
  "(bill of {p0})": "({p0} चे बिल)",
  "(hidden)": "(लपवलेले)",
  "(inactive)": "(निष्क्रिय)",
  "(you)": "(तुम्ही)",
  "({p0} of 12)": "(12 पैकी {p0})",
  "({p0} total items)": "(एकूण {p0} वस्तू)",
  "({p0}% of the price) ·": "(किमतीच्या {p0}%) ·",
  ", AWB": ", AWB",
  ", in {p0} days on average": ", सरासरी {p0} दिवसांत",
  ". Reports count a salary on the day it was paid.": ". पगार दिलेल्या दिवशी रिपोर्टमध्ये मोजला जातो.",
  "/{p0} · {p1} product{p2}": "/{p0} · {p1} उत्पादने",
  "1. Install Google Authenticator": "1. Google Authenticator इन्स्टॉल करा",
  "2. Scan this QR code in the app": "2. ॲपमध्ये हा QR कोड स्कॅन करा",
  "3. Enter the 6-digit code the app shows": "3. ॲपमध्ये दिसणारा 6 अंकी कोड टाका",
  "3.1(a) Outward taxable supplies": "3.1(a) बाह्य करपात्र पुरवठा",
  "3.2 To consumers in {p0}": "3.2 {p0} मधील ग्राहकांना",
  "4(A)(5) Input tax credit: {p0}": "4(A)(5) इनपुट टॅक्स क्रेडिट: {p0}",
  "A bill is attached. Choose a file to replace it.": "बिल जोडलेले आहे. ते बदलण्यासाठी फाइल निवडा.",
  "A new address": "नवीन पत्ता",
  "A new colour of a saree you already sell": "आधीपासून विकत असलेल्या साडीचा नवीन रंग",
  "A payment arrived that the system did not expect. Check it.": "अपेक्षित नसलेले पेमेंट आले आहे. ते तपासा.",
  "A payment attempt failed": "पेमेंटचा प्रयत्न अयशस्वी झाला",
  "A refund could not be sent to Razorpay. Try again.": "Razorpay ला परतावा पाठवता आला नाही. पुन्हा प्रयत्न करा.",
  "A refund failed at Razorpay. Try again or pay the customer back another way.": "Razorpay वर परतावा अयशस्वी झाला. पुन्हा प्रयत्न करा किंवा ग्राहकाला दुसऱ्या मार्गाने पैसे परत करा.",
  "A saree or blouse you haven't sold before": "आधी न विकलेली साडी किंवा ब्लाउज",
  "AK102 or Paithani": "AK102 किंवा पैठणी",
  "AWB, order number or name": "AWB, ऑर्डर क्रमांक किंवा नाव",
  "Account menu": "खाते मेनू",
  "Act on failed delivery": "अयशस्वी डिलिव्हरीवर कारवाई करा",
  "Action items": "करायची कामे",
  "Actions": "कृती",
  "Active": "सक्रिय",
  "Active customers": "सक्रिय ग्राहक",
  "Activity": "हालचाल",
  "Activity, reason or person": "हालचाल, कारण किंवा व्यक्ती",
  "Add a colour": "रंग जोडा",
  "Add a design": "डिझाइन जोडा",
  "Add a saree or colour": "साडी किंवा रंग जोडा",
  "Add a supplier first.": "आधी पुरवठादार जोडा.",
  "Add all colours": "सर्व रंग जोडा",
  "Add capital entry": "भांडवल नोंद जोडा",
  "Add colour": "रंग जोडा",
  "Add colours to products, then record a purchase.": "उत्पादनांना रंग जोडा, मग खरेदी नोंदवा.",
  "Add each colour you sell, with its own SKU and price.": "तुम्ही विकत असलेला प्रत्येक रंग, त्याच्या SKU आणि किमतीसह जोडा.",
  "Add entry": "नोंद जोडा",
  "Add expense": "खर्च जोडा",
  "Add pieces (found, recount)": "नग जोडा (सापडलेले, पुनर्मोजणी)",
  "Add supplier": "पुरवठादार जोडा",
  "Add the shops and weavers you buy from.": "तुम्ही ज्या दुकानांकडून आणि विणकरांकडून खरेदी करता ते जोडा.",
  "Add to stock": "स्टॉकमध्ये जोडा",
  "Add to stock?": "स्टॉकमध्ये जोडायचे?",
  "Address": "पत्ता",
  "Adjust": "बदल करा",
  "Adjusted down": "कमी केले",
  "Adjusted up": "वाढवले",
  "Admin": "ॲडमिन",
  "Administration": "प्रशासन",
  "After": "नंतर",
  "All": "सर्व",
  "All (not archived)": "सर्व (संग्रहित नसलेले)",
  "All activity": "सर्व हालचाली",
  "All categories": "सर्व श्रेणी",
  "All changes": "सर्व बदल",
  "All colours": "सर्व रंग",
  "All parcels": "सर्व पार्सल",
  "All returns": "सर्व परतावे",
  "All roles": "सर्व भूमिका",
  "All sales": "सर्व सेल",
  "All statuses": "सर्व स्थिती",
  "Amount": "रक्कम",
  "Amount (₹)": "रक्कम (₹)",
  "Amount off (₹)": "सवलत रक्कम (₹)",
  "Amount paid (₹)": "भरलेली रक्कम (₹)",
  "An estimate, not audited accounts. Cost of sarees sold uses each colour's latest purchase cost when it sold, less pieces that came back into stock. Expenses and Razorpay fees are counted without the GST you claim back.": "हा अंदाज आहे, लेखापरीक्षित हिशेब नाही. विकलेल्या साड्यांच्या खर्चासाठी विक्रीच्या वेळी प्रत्येक रंगाची नवीनतम खरेदी किंमत वापरली जाते, स्टॉकमध्ये परत आलेले नग वजा करून. खर्च आणि Razorpay शुल्क तुम्ही परत मिळवता त्या GST शिवाय मोजले जातात.",
  "An invoice is created when a payment is confirmed.": "पेमेंटची खात्री झाल्यावर इनव्हॉइस तयार होते.",
  "Andaman and Nicobar Islands": "अंदमान आणि निकोबार बेटे",
  "Andhra Pradesh": "आंध्र प्रदेश",
  "Another colour": "आणखी एक रंग",
  "Any stock": "कोणताही स्टॉक",
  "App": "ॲप",
  "Applies to invoices issued from now on. Invoices already issued keep their rate. Check with your CA first.": "आतापासून दिलेल्या इनव्हॉइसना लागू. आधी दिलेल्या इनव्हॉइसचा दर तसाच राहतो. आधी तुमच्या CA शी बोला.",
  "Approve": "मंजूर करा",
  "Approve this return": "हा परतावा मंजूर करा",
  "Approved, book pickup": "मंजूर, पिकअप बुक करा",
  "Archive": "संग्रहित करा",
  "Archived": "संग्रहित",
  "Archived.": "संग्रहित केले.",
  "Arrived, inspect it": "पोहोचले, तपासा",
  "Arunachal Pradesh": "अरुणाचल प्रदेश",
  "Ask the courier to try again": "कुरिअरला पुन्हा प्रयत्न करायला सांगा",
  "Assam": "आसाम",
  "At least 10 characters.": "किमान 10 अक्षरे.",
  "At least 1200 pixels wide. JPEG, PNG or WebP.": "किमान 1200 पिक्सेल रुंद. JPEG, PNG किंवा WebP.",
  "At sale prices, across all of a customer's orders in this sale (matched by account, email or phone). Leave empty for no limit.": "सेल किमतीवर, या सेलमधील ग्राहकाच्या सर्व ऑर्डरमध्ये (खाते, ईमेल किंवा फोनवरून जुळवून). मर्यादा नको असल्यास रिकामे ठेवा.",
  "At {p0}: GST inside {p1}, GST to pay after input credit {p2}.": "{p0} वर: {p1} मध्ये GST, इनपुट क्रेडिटनंतर भरायचा GST {p2}.",
  "Attach photo or PDF": "फोटो किंवा PDF जोडा",
  "Attempts": "प्रयत्न",
  "Audit log": "ऑडिट लॉग",
  "Authenticator code": "Authenticator कोड",
  "Authenticator not set up": "Authenticator सेट केलेले नाही",
  "Authenticator reset": "Authenticator रीसेट",
  "Available": "उपलब्ध",
  "Average order": "सरासरी ऑर्डर",
  "Awaiting payment": "पेमेंटची वाट",
  "B2CL: large inter-state invoices": "B2CL: मोठी आंतरराज्य इनव्हॉइस",
  "B2CS: consumer sales by state and rate (after credit notes)": "B2CS: राज्य आणि दरानुसार ग्राहक विक्री (क्रेडिट नोटनंतर)",
  "Back": "मागे",
  "Back in the packing queue": "पुन्हा पॅकिंग रांगेत",
  "Back on sale": "पुन्हा विक्रीला",
  "Back to draft: hidden from customers.": "पुन्हा ड्राफ्ट: ग्राहकांपासून लपवले.",
  "Back to sign in": "साइन इनवर परत",
  "Back with us": "आपल्याकडे परत",
  "Backup code": "बॅकअप कोड",
  "Bags left with items": "वस्तू असलेल्या सोडलेल्या बॅग",
  "Banarasi": "बनारसी",
  "Banarasi Kadhua Silk": "बनारसी कढुआ सिल्क",
  "Bank transfer": "बँक ट्रान्सफर",
  "Banner description": "बॅनरचे वर्णन",
  "Banner uploaded.": "बॅनर अपलोड झाला.",
  "Before": "आधी",
  "Before GST": "GST पूर्वी",
  "Before GST, less refunds": "GST पूर्वी, परतावे वजा करून",
  "Before publishing": "प्रकाशित करण्यापूर्वी",
  "Bihar": "बिहार",
  "Bill": "बिल",
  "Bill date": "बिलाची तारीख",
  "Bill number": "बिल क्रमांक",
  "Bill number or supplier": "बिल क्रमांक किंवा पुरवठादार",
  "Bill photo": "बिलाचा फोटो",
  "Bill photo attached (private).": "बिलाचा फोटो जोडला (खाजगी).",
  "Bill photo attached.": "बिलाचा फोटो जोडला.",
  "Bill photo or PDF (optional)": "बिलाचा फोटो किंवा PDF (ऐच्छिक)",
  "Bill total ({p0} pieces)": "बिलाची एकूण रक्कम ({p0} नग)",
  "Bills": "बिले",
  "Bills added to stock appear here by their bill date.": "स्टॉकमध्ये जोडलेली बिले त्यांच्या बिलाच्या तारखेनुसार इथे दिसतात.",
  "Blouse": "ब्लाउज",
  "Blouse piece length (m)": "ब्लाउज पीसची लांबी (मी)",
  "Blouses": "ब्लाउज",
  "Book WhatsApp and Instagram orders, cancel unpacked orders, look up customers.": "WhatsApp आणि Instagram ऑर्डर बुक करणे, पॅक न झालेल्या ऑर्डर रद्द करणे, ग्राहक शोधणे.",
  "Book an order": "ऑर्डर बुक करा",
  "Book and create payment link": "बुक करा आणि पेमेंट लिंक तयार करा",
  "Book pickup": "पिकअप बुक करा",
  "Book pickup for {p0} packed parcel{p1}": "{p0} पॅक केलेल्या पार्सलसाठी पिकअप बुक करा",
  "Book reverse pickup": "रिव्हर्स पिकअप बुक करा",
  "Booked (waiting for payment)": "बुक केलेले (पेमेंटची वाट)",
  "Booked by staff": "स्टाफने बुक केलेले",
  "Bookings": "बुकिंग",
  "Bought": "खरेदी केले",
  "Box": "बॉक्स",
  "Breadcrumb": "ब्रेडक्रंब",
  "Breadth (cm)": "रुंदी (सेमी)",
  "Break down by": "यानुसार विभागणी",
  "By": "कडून",
  "By / reason": "कोणी / कारण",
  "By colour": "रंगानुसार",
  "By day": "दिवसानुसार",
  "By month": "महिन्यानुसार",
  "CGST + SGST (same state)": "CGST + SGST (त्याच राज्यात)",
  "CSV:": "CSV:",
  "Can't scan? Enter this key in the app:": "स्कॅन होत नाही? ॲपमध्ये ही की टाका:",
  "Cancel": "रद्द करा",
  "Cancel order": "ऑर्डर रद्द करा",
  "Cancel parcel": "पार्सल रद्द करा",
  "Cancel the order and refund the customer": "ऑर्डर रद्द करा आणि ग्राहकाला पैसे परत करा",
  "Cancel this order": "ही ऑर्डर रद्द करा",
  "Cancel this parcel": "हे पार्सल रद्द करा",
  "Cancellation email": "रद्द केल्याचा ईमेल",
  "Cancelled": "रद्द",
  "Capital": "भांडवल",
  "Capital letters, numbers and hyphens.": "कॅपिटल अक्षरे, अंक आणि हायफन.",
  "Card": "कार्ड",
  "Care instructions": "काळजी घेण्याच्या सूचना",
  "Care instructions in Marathi": "मराठीत काळजी घेण्याच्या सूचना",
  "Cash": "रोख",
  "Catalog": "कॅटलॉग",
  "Categories": "श्रेणी",
  "Category": "श्रेणी",
  "Category saved.": "श्रेणी जतन केली.",
  "Chandigarh": "चंदीगड",
  "Change": "बदला",
  "Change the rate": "दर बदला",
  "Changed role permissions": "भूमिकेच्या परवानग्या बदलल्या",
  "Changed roles": "भूमिका बदलल्या",
  "Channel": "माध्यम",
  "Check the highlighted fields.": "ठळक केलेली फील्ड तपासा.",
  "Checkout": "चेकआउट",
  "Chhattisgarh": "छत्तीसगड",
  "Choose": "निवडा",
  "Choose a new password": "नवीन पासवर्ड निवडा",
  "Choose a saree by code or name": "कोड किंवा नावाने साडी निवडा",
  "Choose a size": "आकार निवडा",
  "Choose the saree this colour belongs to.": "हा रंग कोणत्या साडीचा आहे ती निवडा.",
  "Chosen categories": "निवडलेल्या श्रेणी",
  "Chosen colours": "निवडलेले रंग",
  "Chosen designs": "निवडलेली डिझाइन",
  "City": "शहर",
  "Clear": "पुसा",
  "Click in a field on the page first, then come back here.": "आधी पानावरील फील्डमध्ये क्लिक करा, मग इथे परत या.",
  "Close": "बंद करा",
  "Closed": "बंद",
  "Code": "कोड",
  "Code, name or SKU": "कोड, नाव किंवा SKU",
  "Code, product or SKU": "कोड, उत्पादन किंवा SKU",
  "Code, product, colour or SKU": "कोड, उत्पादन, रंग किंवा SKU",
  "Colour": "रंग",
  "Colour name": "रंगाचे नाव",
  "Colour name in Marathi": "मराठीत रंगाचे नाव",
  "Colour saved.": "रंग जतन केला.",
  "Colours": "रंग",
  "Comes with a blouse piece": "सोबत ब्लाउज पीस",
  "Coming back": "परत येत आहे",
  "Coming back (RTO)": "परत येत आहे (RTO)",
  "Coming back to us": "आपल्याकडे परत येत आहे",
  "Compared with {p0}": "{p0} शी तुलना",
  "Compared with {p0}.": "{p0} शी तुलना.",
  "Completed": "पूर्ण",
  "Confirm": "खात्री करा",
  "Confirm it's you": "हे तुम्हीच आहात याची खात्री करा",
  "Confirm password": "पासवर्डची खात्री करा",
  "Confirmed": "निश्चित",
  "Confirmed identity": "ओळख निश्चित केली",
  "Continue": "पुढे चला",
  "Copied": "कॉपी झाले",
  "Copied.": "कॉपी झाले.",
  "Copy": "कॉपी करा",
  "Copy codes": "कोड कॉपी करा",
  "Copy link": "लिंक कॉपी करा",
  "Copying is blocked here. Select the text and press Ctrl+C.": "इथे कॉपी करता येत नाही. मजकूर निवडा आणि Ctrl+C दाबा.",
  "Cost each": "प्रत्येकी खर्च",
  "Cost each (₹)": "प्रत्येकी खर्च (₹)",
  "Cost to the business": "व्यवसायाचा खर्च",
  "Cost {p0} + GST {p1}% {p2} =": "खर्च {p0} + GST {p1}% {p2} =",
  "Could not reach the server. Check your connection and try again.": "सर्व्हरशी संपर्क झाला नाही. इंटरनेट तपासा आणि पुन्हा प्रयत्न करा.",
  "Courier": "कुरिअर",
  "Courier bags and tape": "कुरिअर बॅग आणि टेप",
  "Courier cost not reimbursed yet.": "कुरिअर खर्च अजून परत दिलेला नाही.",
  "Courier cost on the receipt (₹)": "पावतीवरील कुरिअर खर्च (₹)",
  "Courier cost reimbursed": "कुरिअर खर्च परत दिला",
  "Courier pouch": "कुरिअर पाउच",
  "Courier says: “{p0}”": "कुरिअर सांगते: “{p0}”",
  "Create": "तयार करा",
  "Create one": "एक तयार करा",
  "Create shipment and label": "शिपमेंट आणि लेबल तयार करा",
  "Create the payment link": "पेमेंट लिंक तयार करा",
  "Credit note PDF": "क्रेडिट नोट PDF",
  "Credit note {p0} (−{p1})": "क्रेडिट नोट {p0} (−{p1})",
  "Credit note {p0} · −{p1}": "क्रेडिट नोट {p0} · −{p1}",
  "Credit notes": "क्रेडिट नोट",
  "Ctrl+G switches": "Ctrl+G ने बदला",
  "Custom": "कस्टम",
  "Custom dates": "निवडलेल्या तारखा",
  "Customer": "ग्राहक",
  "Customer emails and follow-up tasks are retried automatically for about an hour. Those that still fail appear here: fix the cause (for example the email settings), then retry.": "ग्राहकांचे ईमेल आणि पुढची कामे सुमारे एक तास आपोआप पुन्हा प्रयत्न केली जातात. तरीही अयशस्वी झालेली इथे दिसतात: कारण दुरुस्त करा (उदा. ईमेल सेटिंग्ज), मग पुन्हा प्रयत्न करा.",
  "Customer is sending it": "ग्राहक पाठवत आहे",
  "Customer sends it themselves": "ग्राहक स्वतः पाठवतो",
  "Customer will send it": "ग्राहक पाठवेल",
  "Customers in your state: CGST {p0}% + SGST {p1}%. Other states: IGST {p2}%. Prices already include GST; invoices show how much of the price is tax.": "तुमच्या राज्यातील ग्राहक: CGST {p0}% + SGST {p1}%. इतर राज्ये: IGST {p2}%. किमतींमध्ये GST आधीच समाविष्ट आहे; इनव्हॉइसवर किमतीतील कराचा भाग दिसतो.",
  "Customers quote this on WhatsApp. Two letters and three digits, like AK102. Fixed once the saree is ordered.": "ग्राहक WhatsApp वर हा कोड सांगतात. दोन अक्षरे आणि तीन अंक, जसे AK102. साडीची ऑर्डर आल्यावर बदलता येत नाही.",
  "Customers see “only a few left”.": "ग्राहकांना “फक्त काही शिल्लक” दिसते.",
  "Customers who choose Marathi on the website see these. Leave a field empty to show the English.": "वेबसाइटवर मराठी निवडणाऱ्या ग्राहकांना हे दिसते. इंग्रजी दाखवण्यासाठी फील्ड रिकामे ठेवा.",
  "Dadra and Nagar Haveli and Daman and Diu": "दादरा आणि नगर हवेली आणि दमण आणि दीव",
  "Damaged": "खराब",
  "Damaged or defective pieces only, requested within 24 hours of delivery with the opening video. A return that reaches you is always refunded.": "फक्त खराब किंवा सदोष नग, डिलिव्हरीनंतर 24 तासांत उघडतानाच्या व्हिडिओसह मागितलेले. तुमच्यापर्यंत पोहोचलेल्या परताव्याचे पैसे नेहमी परत दिले जातात.",
  "Damaged written off": "खराब म्हणून काढले",
  "Damaged: to damaged stock": "खराब: खराब स्टॉकमध्ये",
  "Dark": "डार्क",
  "Dashboard": "डॅशबोर्ड",
  "Date": "तारीख",
  "Day": "दिवस",
  "Decision: “{p0}” ({p1})": "निर्णय: “{p0}” ({p1})",
  "Delete": "हटवा",
  "Delete draft": "ड्राफ्ट हटवा",
  "Delete test data": "चाचणी डेटा हटवा",
  "Delete test data?": "चाचणी डेटा हटवायचा?",
  "Delete this entry?": "ही नोंद हटवायची?",
  "Delete this expense?": "हा खर्च हटवायचा?",
  "Delete this salary payment?": "हे पगार पेमेंट हटवायचे?",
  "Deleted 30 days after the return closed.": "परतावा बंद झाल्यानंतर 30 दिवसांनी हटवले.",
  "Deleted {p0} rows on {p1}.": "{p1} रोजी {p0} ओळी हटवल्या.",
  "Deleting test data": "चाचणी डेटा हटवत आहे",
  "Delhi": "दिल्ली",
  "Deliver to": "येथे पोहोचवा",
  "Delivered": "पोहोचले",
  "Delivered email": "पोहोचल्याचा ईमेल",
  "Delivered to the customer": "ग्राहकाला पोहोचले",
  "Delivery failed": "डिलिव्हरी अयशस्वी",
  "Delivery issues": "डिलिव्हरीच्या अडचणी",
  "Description": "वर्णन",
  "Description in Marathi": "मराठीत वर्णन",
  "Details": "तपशील",
  "Differ": "फरक",
  "Differs": "फरक आहे",
  "Discount": "सवलत",
  "Discount given": "दिलेली सवलत",
  "Dismiss": "बंद करा",
  "Diwali Sale": "दिवाळी सेल",
  "Diwali Sale: 20% off silk sarees": "दिवाळी सेल: सिल्क साड्यांवर 20% सूट",
  "Documents": "कागदपत्रे",
  "Documents issued": "दिलेली कागदपत्रे",
  "Done": "झाले",
  "Download CSV": "CSV डाउनलोड करा",
  "Draft": "ड्राफ्ट",
  "Draft deleted.": "ड्राफ्ट हटवला.",
  "Draft saved. Stock changes only when you add it to stock.": "ड्राफ्ट जतन केला. स्टॉकमध्ये जोडल्यावरच स्टॉक बदलतो.",
  "Draft: stock not added yet": "ड्राफ्ट: स्टॉक अजून जोडलेला नाही",
  "Dry clean only.": "फक्त ड्राय क्लीन.",
  "Each code works once, if you lose your phone. They won't be shown again.": "फोन हरवल्यास प्रत्येक कोड एकदाच चालतो. ते पुन्हा दाखवले जाणार नाहीत.",
  "Each figure is what the reports show, compared with what the test data actually did, to the paisa: every month, each financial year and the whole period.": "प्रत्येक आकडा रिपोर्टमध्ये दिसणारा आहे, चाचणी डेटाने प्रत्यक्ष केलेल्याशी पैशापर्यंत तुलना करून: प्रत्येक महिना, प्रत्येक आर्थिक वर्ष आणि संपूर्ण कालावधी.",
  "Edit": "संपादित करा",
  "Edit category": "श्रेणी संपादित करा",
  "Edit colour": "रंग संपादित करा",
  "Edit entry": "नोंद संपादित करा",
  "Edit expense": "खर्च संपादित करा",
  "Edit salary payment": "पगार पेमेंट संपादित करा",
  "Edit supplier": "पुरवठादार संपादित करा",
  "Elbow length": "कोपरापर्यंत",
  "Email": "ईमेल",
  "End now": "आताच संपवा",
  "End the sale now?": "सेल आताच संपवायचा?",
  "Ended": "संपला",
  "Ended {p0}. Orders keep the prices they were placed at.": "{p0} रोजी संपला. ऑर्डरच्या किमती दिल्या तेव्हाच्याच राहतात.",
  "Ends": "संपतो",
  "Ends (India time)": "संपतो (भारतीय वेळ)",
  "English": "English",
  "English text": "इंग्रजी मजकूर",
  "Enter a price like 12999 or 12999.50.": "12999 किंवा 12999.50 अशी किंमत टाका.",
  "Enter an MRP like 15999.": "15999 अशी MRP टाका.",
  "Enter one of the backup codes you saved when setting up.": "सेटअप करताना जतन केलेल्या बॅकअप कोडपैकी एक टाका.",
  "Enter the GST on the bill, or leave it empty.": "बिलावरील GST टाका, किंवा रिकामे ठेवा.",
  "Enter the amount paid, like 1180 or 1180.50.": "भरलेली रक्कम टाका, जसे 1180 किंवा 1180.50.",
  "Enter the amount paid, like 12000.": "भरलेली रक्कम टाका, जसे 12000.",
  "Enter the amount, like 500000.": "रक्कम टाका, जसे 500000.",
  "Enter the colour name.": "रंगाचे नाव टाका.",
  "Enter the courier AWB, the cost from the receipt, and attach the receipt.": "कुरिअर AWB, पावतीवरील खर्च टाका आणि पावती जोडा.",
  "Enter your code": "तुमचा कोड टाका",
  "Entry deleted.": "नोंद हटवली.",
  "Equipment": "उपकरणे",
  "Equipment bought": "उपकरणे खरेदी",
  "Equipment repair": "उपकरण दुरुस्ती",
  "Estimated GST to pay": "भरायचा अंदाजे GST",
  "Estimated profit": "अंदाजे नफा",
  "Every colour in stock sold recently.": "स्टॉकमधील प्रत्येक रंग अलीकडे विकला गेला.",
  "Every email and task has been delivered.": "प्रत्येक ईमेल आणि काम पोहोचले आहे.",
  "Every report matches: {p0} figures checked": "प्रत्येक रिपोर्ट जुळतो: {p0} आकडे तपासले",
  "Every stock change, newest first. The history can't be edited; mistakes are corrected with a new change.": "स्टॉकमधील प्रत्येक बदल, नवीन आधी. इतिहास बदलता येत नाही; चुका नवीन बदलाने दुरुस्त केल्या जातात.",
  "Everything": "सर्व काही",
  "Everything the test data added is removed: products, photos, customers, orders, invoices, purchases, expenses and their history. Anything you added yourself stays.": "चाचणी डेटाने जोडलेले सर्व काढले जाते: उत्पादने, फोटो, ग्राहक, ऑर्डर, इनव्हॉइस, खरेदी, खर्च आणि त्यांचा इतिहास. तुम्ही स्वतः जोडलेले तसेच राहते.",
  "Everything, including refunds, money reports and staff.": "सर्व काही, परतावे, पैशांचे रिपोर्ट आणि स्टाफसह.",
  "Existing customer": "जुना ग्राहक",
  "Expected": "अपेक्षित",
  "Expense": "खर्च",
  "Expense deleted.": "खर्च हटवला.",
  "Expense saved.": "खर्च जतन केला.",
  "Expenses": "खर्च",
  "Expenses by kind": "प्रकारानुसार खर्च",
  "Expenses, fees, return shipping, salaries": "खर्च, शुल्क, परतीचे शिपिंग, पगार",
  "Expenses: ": "खर्च: ",
  "Fabric": "कापड",
  "Fabric in Marathi": "मराठीत कापड",
  "Fabric length (m)": "कापडाची लांबी (मी)",
  "Failed after every retry": "प्रत्येक प्रयत्नानंतरही अयशस्वी",
  "Failed deliveries": "अयशस्वी डिलिव्हरी",
  "Failed delivery": "अयशस्वी डिलिव्हरी",
  "Failed payments": "अयशस्वी पेमेंट",
  "Failed sign-in": "अयशस्वी साइन इन",
  "Figure": "आकडा",
  "Figures checked": "तपासलेले आकडे",
  "Figures for your CA to file GSTR-1 and GSTR-3B. Every sale is to a consumer, so sales are B2C.": "GSTR-1 आणि GSTR-3B भरण्यासाठी तुमच्या CA साठी आकडे. प्रत्येक विक्री ग्राहकाला आहे, त्यामुळे विक्री B2C आहे.",
  "Figures that differ": "फरक असलेले आकडे",
  "Finance": "वित्त",
  "Find the customer": "ग्राहक शोधा",
  "Fine: back on sale": "ठीक: पुन्हा विक्रीला",
  "Finish packing": "पॅकिंग पूर्ण करा",
  "First published {p0}": "पहिल्यांदा प्रकाशित {p0}",
  "Fix the highlighted colour and save again. The colours above it are already saved.": "ठळक केलेला रंग दुरुस्त करा आणि पुन्हा जतन करा. त्याच्या वरचे रंग आधीच जतन झाले आहेत.",
  "Fixed": "ठराविक",
  "Fixed sale price": "ठराविक सेल किंमत",
  "Flat ₹ off": "ठराविक ₹ सूट",
  "For": "साठी",
  "For customers who order on WhatsApp, Instagram or by phone. Website prices and the current sale apply. The stock is held for 24 hours while the customer pays the link you send them.": "WhatsApp, Instagram किंवा फोनवर ऑर्डर देणाऱ्या ग्राहकांसाठी. वेबसाइटच्या किमती आणि चालू सेल लागू होतात. तुम्ही पाठवलेल्या लिंकवर ग्राहक पैसे भरेपर्यंत स्टॉक 24 तास राखून ठेवला जातो.",
  "For example Banarasi, Kanjeevaram, Wedding, Blouses.": "उदा. बनारसी, कांजीवरम, लग्न, ब्लाउज.",
  "For {p0}.": "{p0} साठी.",
  "Forgot your password?": "पासवर्ड विसरलात?",
  "Free": "मोफत",
  "From": "पासून",
  "From supplier's state": "पुरवठादाराच्या राज्यातून",
  "From the GSTIN": "GSTIN वरून",
  "From the Play Store or App Store. Microsoft Authenticator and Authy work too.": "Play Store किंवा App Store मधून. Microsoft Authenticator आणि Authy सुद्धा चालतात.",
  "From the start": "सुरुवातीपासून",
  "From your CA. Needed on invoices.": "तुमच्या CA कडून. इनव्हॉइसवर आवश्यक.",
  "GST collected, after refunds": "परताव्यानंतर जमा झालेला GST",
  "GST included.": "GST समाविष्ट.",
  "GST is now {p0}% for invoices from now on.": "आतापासूनच्या इनव्हॉइससाठी GST आता {p0}% आहे.",
  "GST on all products": "सर्व उत्पादनांवर GST",
  "GST on bill (₹)": "बिलावरील GST (₹)",
  "GST on sales": "विक्रीवरील GST",
  "GST on the bill": "बिलावरील GST",
  "GST on the bill (₹)": "बिलावरील GST (₹)",
  "GST paid": "भरलेला GST",
  "GST rate (%)": "GST दर (%)",
  "GST returns": "GST रिटर्न",
  "GST you can claim back": "परत मिळवता येणारा GST",
  "GSTIN (optional)": "GSTIN (ऐच्छिक)",
  "GSTR-1": "GSTR-1",
  "GSTR-3B summary": "GSTR-3B सारांश",
  "Gateway fees": "गेटवे शुल्क",
  "Gives 5% off on 10+ pieces": "10+ नगांवर 5% सूट देतो",
  "Goa": "गोवा",
  "Good afternoon": "शुभ दुपार",
  "Good evening": "शुभ संध्याकाळ",
  "Good morning": "सुप्रभात",
  "Gross margin": "एकूण मार्जिन",
  "Gross margin {p0}": "एकूण मार्जिन {p0}",
  "Group products for the storefront menu. One level of sub-categories.": "स्टोअरफ्रंट मेनूसाठी उत्पादनांचे गट करा. उप-श्रेणींचा एक स्तर.",
  "Gujarat": "गुजरात",
  "HSN code": "HSN कोड",
  "HSN summary": "HSN सारांश",
  "Haryana": "हरियाणा",
  "Has an account": "खाते आहे",
  "Have it returned to us": "आपल्याकडे परत पाठवा",
  "Height (cm)": "उंची (सेमी)",
  "Hide": "लपवा",
  "Himachal Pradesh": "हिमाचल प्रदेश",
  "History": "इतिहास",
  "Home-page banner": "होम पेज बॅनर",
  "House, street, area": "घर, रस्ता, परिसर",
  "How each colour sold": "प्रत्येक रंग कसा विकला गेला",
  "How it adds up": "हिशेब कसा जुळतो",
  "How it's woven, what makes it special, how it drapes.": "ती कशी विणली आहे, तिचे वैशिष्ट्य काय, ती कशी नेसली जाते.",
  "I've saved them, continue": "मी ते जतन केले, पुढे चला",
  "IGST (other state)": "IGST (इतर राज्य)",
  "If {p0} belongs to a staff account, a reset link is on its way. It works for 60 minutes.": "{p0} स्टाफ खात्याचा असल्यास, रीसेट लिंक पाठवली आहे. ती 60 मिनिटे चालते.",
  "In Marathi (मराठी)": "मराठीत",
  "In progress": "सुरू आहे",
  "In stock": "स्टॉकमध्ये",
  "In the sale": "सेलमध्ये",
  "In transit": "वाटेत",
  "Includes Diwali bonus": "दिवाळी बोनससह",
  "Input tax credit": "इनपुट टॅक्स क्रेडिट",
  "Inside": "आत",
  "Inspect and refund": "तपासा आणि परतावा द्या",
  "Internet and phone": "इंटरनेट आणि फोन",
  "Invite not accepted": "आमंत्रण स्वीकारले नाही",
  "Invite sent to {p0}. The link works for 72 hours.": "{p0} ला आमंत्रण पाठवले. लिंक 72 तास चालते.",
  "Invite staff": "स्टाफला आमंत्रित करा",
  "Invited staff": "आमंत्रित स्टाफ",
  "Invoice": "इनव्हॉइस",
  "Invoice PDF": "इनव्हॉइस PDF",
  "Invoice or order number, name": "इनव्हॉइस किंवा ऑर्डर क्रमांक, नाव",
  "Invoice {p0}": "इनव्हॉइस {p0}",
  "Invoices": "इनव्हॉइस",
  "Issued": "दिले",
  "It is saved as a draft and the colours are added to this bill. Add photos and details under Products before customers can see it.": "हे ड्राफ्ट म्हणून जतन होते आणि रंग या बिलात जोडले जातात. ग्राहकांना दिसण्यापूर्वी उत्पादनांमध्ये फोटो आणि तपशील जोडा.",
  "It starts as a draft. Add colours, photos and details, then publish.": "हे ड्राफ्ट म्हणून सुरू होते. रंग, फोटो आणि तपशील जोडा, मग प्रकाशित करा.",
  "It starts by itself at {p0} and ends at {p1}. Once it starts, the discount and what it covers can't change.": "हा {p0} ला आपोआप सुरू होतो आणि {p1} ला संपतो. सुरू झाल्यावर सवलत आणि त्यात काय येते ते बदलता येत नाही.",
  "Items": "वस्तू",
  "Its pieces are taken back out of stock. Use this only for a bill entered by mistake.": "त्याचे नग स्टॉकमधून परत काढले जातात. फक्त चुकून नोंदवलेल्या बिलासाठी वापरा.",
  "JPEG, PNG or WebP, at least 800 px on the shorter side. Location data from phones is removed.": "JPEG, PNG किंवा WebP, लहान बाजूला किमान 800 px. फोनमधील ठिकाणाची माहिती काढली जाते.",
  "Jammu and Kashmir": "जम्मू आणि काश्मीर",
  "Jharkhand": "झारखंड",
  "Karnataka": "कर्नाटक",
  "Keep it": "ठेवा",
  "Kerala": "केरळ",
  "Label": "लेबल",
  "Label printed": "लेबल छापले",
  "Ladakh": "लडाख",
  "Lakshadweep": "लक्षद्वीप",
  "Landmark (optional)": "खूण (ऐच्छिक)",
  "Large saree box": "मोठा साडी बॉक्स",
  "Last 30 days": "मागील 30 दिवस",
  "Last 7 days": "मागील 7 दिवस",
  "Last financial year": "मागील आर्थिक वर्ष",
  "Last month": "मागील महिना",
  "Last sale": "शेवटची विक्री",
  "Last sign-in": "शेवटचे साइन इन",
  "Leave empty and one is given automatically.": "रिकामे ठेवल्यास आपोआप दिला जातो.",
  "Leave empty if none.": "नसल्यास रिकामे ठेवा.",
  "Leave “GST on bill” empty to use the calculated amount; type the bill's figure if it differs by rounding (within ₹1).": "मोजलेली रक्कम वापरण्यासाठी “बिलावरील GST” रिकामे ठेवा; राउंडिंगमुळे फरक असल्यास (₹1 च्या आत) बिलावरील आकडा टाका.",
  "Length (cm)": "लांबी (सेमी)",
  "Less cost of sarees sold": "वजा विकलेल्या साड्यांचा खर्च",
  "Less expenses (without claimable GST)": "वजा खर्च (परत मिळणाऱ्या GST शिवाय)",
  "Less refunds (credit notes)": "वजा परतावे (क्रेडिट नोट)",
  "Less salaries": "वजा पगार",
  "Light": "लाइट",
  "Line total": "ओळीची एकूण रक्कम",
  "Live": "चालू",
  "Live until {p0}. The discount and what it covers are locked; you can still change the name, the end time and the countdown.": "{p0} पर्यंत चालू. सवलत आणि त्यात काय येते ते लॉक आहे; नाव, संपण्याची वेळ आणि काउंटडाउन अजून बदलता येते.",
  "Load test data": "चाचणी डेटा लोड करा",
  "Load test data?": "चाचणी डेटा लोड करायचा?",
  "Loaded by {p0} on {p1}.": "{p1} रोजी {p0} यांनी लोड केला.",
  "Loading takes about 2–5 minutes. You can leave this page; the queue worker carries on.": "लोड होण्यास सुमारे 2–5 मिनिटे लागतात. तुम्ही हे पान सोडू शकता; queue worker काम चालू ठेवतो.",
  "Loading test data": "चाचणी डेटा लोड होत आहे",
  "Loading…": "लोड होत आहे…",
  "Loads a made-up Devi Sarees with about a year of trading: 100 sarees and blouses in 4–5 colours with at least 50 pieces each, suppliers and purchase bills, customers, about 1,500 orders in every state (paid, packed, delivered, cancelled, refunded, returned), SALE events, expenses, salaries and capital. It is made through the same steps as real orders, so loading it also tests them. Nothing is sent to customers, Razorpay, Shiprocket or WhatsApp. Afterwards every report is checked against what the test data did.": "सुमारे एका वर्षाच्या व्यवहारासह एक काल्पनिक Devi Sarees लोड करतो: 4–5 रंगांतील 100 साड्या आणि ब्लाउज, प्रत्येकी किमान 50 नग, पुरवठादार आणि खरेदी बिले, ग्राहक, प्रत्येक स्थितीतील सुमारे 1,500 ऑर्डर (भरलेल्या, पॅक केलेल्या, पोहोचलेल्या, रद्द, परतावा दिलेल्या, परत आलेल्या), SALE, खर्च, पगार आणि भांडवल. हे खऱ्या ऑर्डरच्याच पायऱ्यांनी बनते, त्यामुळे लोड केल्याने त्यांचीही चाचणी होते. ग्राहक, Razorpay, Shiprocket किंवा WhatsApp ला काहीही पाठवले जात नाही. नंतर प्रत्येक रिपोर्ट चाचणी डेटाने केलेल्याशी तपासला जातो.",
  "Low stock": "कमी स्टॉक",
  "Low-stock warning at": "कमी स्टॉकची सूचना येथे",
  "MRP (₹, optional)": "MRP (₹, ऐच्छिक)",
  "Made from the code and colour": "कोड आणि रंगावरून बनतो",
  "Madhya Pradesh": "मध्य प्रदेश",
  "Maharashtra": "महाराष्ट्र",
  "Main menu": "मुख्य मेनू",
  "Manifest": "मॅनिफेस्ट",
  "Manipur": "मणिपूर",
  "Marathi typing": "मराठी टायपिंग",
  "Margin": "मार्जिन",
  "Margin is before GST: sales without GST less the purchase cost. Sell-through is pieces sold ÷ (sold + still in stock).": "मार्जिन GST पूर्वी आहे: GST शिवाय विक्री वजा खरेदी किंमत. सेल-थ्रू म्हणजे विकलेले नग ÷ (विकलेले + स्टॉकमधील).",
  "Mark as resolved": "सोडवले म्हणून नोंदवा",
  "Mark pieces damaged": "नग खराब म्हणून नोंदवा",
  "Marked as resolved.": "सोडवले म्हणून नोंदवले.",
  "Marked damaged": "खराब म्हणून नोंदवले",
  "Marketing": "मार्केटिंग",
  "Marketing and ads": "मार्केटिंग आणि जाहिराती",
  "Match": "जुळते",
  "Match my device": "माझ्या डिव्हाइसप्रमाणे",
  "Matches": "जुळणारे",
  "Matching sarees": "जुळणाऱ्या साड्या",
  "Meghalaya": "मेघालय",
  "Mizoram": "मिझोराम",
  "Money": "पैसे",
  "Money put in": "घातलेले पैसे",
  "Money taken out": "काढलेले पैसे",
  "Month": "महिना",
  "More address (optional)": "आणखी पत्ता (ऐच्छिक)",
  "Most pieces per customer": "प्रति ग्राहक जास्तीत जास्त नग",
  "Move back to draft": "पुन्हा ड्राफ्टमध्ये न्या",
  "Move its products first": "आधी त्याची उत्पादने हलवा",
  "Move photo {p0} earlier": "फोटो {p0} आधी हलवा",
  "Move photo {p0} later": "फोटो {p0} नंतर हलवा",
  "Moved back to draft.": "पुन्हा ड्राफ्टमध्ये नेले.",
  "Nagaland": "नागालँड",
  "Name": "नाव",
  "Name in Marathi": "मराठीत नाव",
  "Name or GSTIN": "नाव किंवा GSTIN",
  "Name or email": "नाव किंवा ईमेल",
  "Name, phone or email": "नाव, फोन किंवा ईमेल",
  "Needed to claim input tax credit.": "इनपुट टॅक्स क्रेडिट मिळवण्यासाठी आवश्यक.",
  "Needed to claim the GST back.": "GST परत मिळवण्यासाठी आवश्यक.",
  "Needs attention": "लक्ष देणे आवश्यक",
  "Net capital": "निव्वळ भांडवल",
  "Net sales": "निव्वळ विक्री",
  "New category": "नवीन श्रेणी",
  "New customer (no account needed)": "नवीन ग्राहक (खाते लागत नाही)",
  "New password": "नवीन पासवर्ड",
  "New product": "नवीन उत्पादन",
  "New sale": "नवीन सेल",
  "New saree or colour": "नवीन साडी किंवा रंग",
  "Next": "पुढे",
  "Next order to pack: {p0}": "पॅक करायची पुढची ऑर्डर: {p0}",
  "Next page": "पुढचे पान",
  "Next step: finish packing": "पुढची पायरी: पॅकिंग पूर्ण करा",
  "Next step: pack it": "पुढची पायरी: पॅक करा",
  "Next step: print the label and book the pickup": "पुढची पायरी: लेबल छापा आणि पिकअप बुक करा",
  "Next you book the courier pickup; the refund goes out when it reaches you.": "पुढे कुरिअर पिकअप बुक करा; ते तुमच्यापर्यंत पोहोचल्यावर परतावा जातो.",
  "No GSTIN": "GSTIN नाही",
  "No account": "खाते नाही",
  "No active colours are covered yet.": "अजून कोणतेही सक्रिय रंग समाविष्ट नाहीत.",
  "No activity": "कोणतीही हालचाल नाही",
  "No banner. The storefront shows a plain sale strip instead.": "बॅनर नाही. स्टोअरफ्रंटवर त्याऐवजी साधी सेल पट्टी दिसते.",
  "No bill photo yet.": "अजून बिलाचा फोटो नाही.",
  "No capital entries": "भांडवलाच्या नोंदी नाहीत",
  "No categories yet": "अजून श्रेणी नाहीत",
  "No categories yet.": "अजून श्रेणी नाहीत.",
  "No colours": "रंग नाहीत",
  "No colours yet.": "अजून रंग नाहीत.",
  "No data": "डेटा नाही",
  "No data available at the moment": "सध्या डेटा उपलब्ध नाही",
  "No discount": "सवलत नाही",
  "No expenses in this period": "या कालावधीत खर्च नाही",
  "No expenses in this period.": "या कालावधीत खर्च नाही.",
  "No invoices": "इनव्हॉइस नाहीत",
  "No orders found": "ऑर्डर सापडल्या नाहीत",
  "No orders in this period.": "या कालावधीत ऑर्डर नाहीत.",
  "No parcels": "पार्सल नाहीत",
  "No photos yet. Customers can't see a product without one.": "अजून फोटो नाहीत. फोटोशिवाय ग्राहकांना उत्पादन दिसत नाही.",
  "No products yet": "अजून उत्पादने नाहीत",
  "No purchase cost recorded": "खरेदी किंमत नोंदवलेली नाही",
  "No purchase recorded for this colour yet. GST inside {p0} at {p1}%: {p2}.": "या रंगाची अजून खरेदी नोंदवलेली नाही. {p0} मध्ये {p1}% दराने GST: {p2}.",
  "No purchases in this period": "या कालावधीत खरेदी नाही",
  "No purchases yet": "अजून खरेदी नाही",
  "No records found": "नोंदी सापडल्या नाहीत",
  "No returns": "परतावे नाहीत",
  "No salaries paid in this period": "या कालावधीत पगार दिलेला नाही",
  "No sale for (days)": "इतके दिवस विक्री नाही",
  "No sales this month.": "या महिन्यात विक्री नाही.",
  "No sales yet": "अजून विक्री नाही",
  "No sarees yet.": "अजून साड्या नाहीत.",
  "No slow movers": "हळू विकणारे नाहीत",
  "No staff found": "स्टाफ सापडला नाही",
  "No stock": "स्टॉक नाही",
  "No stock changes yet": "अजून स्टॉकमध्ये बदल नाहीत",
  "No supplier activity": "पुरवठादारांची हालचाल नाही",
  "No suppliers yet": "अजून पुरवठादार नाहीत",
  "No test data loaded": "चाचणी डेटा लोड केलेला नाही",
  "No video.": "व्हिडिओ नाही.",
  "None": "काहीही नाही",
  "Not accepted": "स्वीकारले नाही",
  "Not delivered": "पोहोचले नाही",
  "Not finished": "पूर्ण झाले नाही",
  "Not paid": "भरलेले नाही",
  "Not paid yet": "अजून भरलेले नाही",
  "Not ready yet: see the checklist.": "अजून तयार नाही: चेकलिस्ट पाहा.",
  "Note (optional)": "टीप (ऐच्छिक)",
  "Note for the audit log (optional)": "ऑडिट लॉगसाठी टीप (ऐच्छिक)",
  "Note for the courier": "कुरिअरसाठी टीप",
  "Notes": "टिपा",
  "Nothing chosen yet.": "अजून काहीही निवडलेले नाही.",
  "Nothing failed": "काहीही अयशस्वी नाही",
  "Nothing found. Bought something new? Use “New saree or colour”.": "काहीही सापडले नाही. नवीन काही खरेदी केले? “नवीन साडी किंवा रंग” वापरा.",
  "Nothing here": "इथे काहीही नाही",
  "Nothing matches these filters.": "या फिल्टरशी काहीही जुळत नाही.",
  "Nothing matches. Create a saree or blouse, or change the filters.": "काहीही जुळत नाही. साडी किंवा ब्लाउज तयार करा, किंवा फिल्टर बदला.",
  "Nothing matches. Try another search or filter.": "काहीही जुळत नाही. दुसरा शोध किंवा फिल्टर वापरून पाहा.",
  "Nothing needs attention.": "कशाकडेही लक्ष देण्याची गरज नाही.",
  "Nothing sold or in stock": "काहीही विकलेले किंवा स्टॉकमध्ये नाही",
  "Nothing to pack": "पॅक करायला काही नाही",
  "Nothing waiting": "वाट पाहणारे काही नाही",
  "Occasion": "प्रसंग",
  "Occasion in Marathi": "मराठीत प्रसंग",
  "Odisha": "ओडिशा",
  "Oldest since {p0}": "{p0} पासून सर्वात जुने",
  "On hand": "हातात",
  "On the way back": "परत येताना",
  "Only bills added to stock are counted; drafts and voided bills are left out.": "फक्त स्टॉकमध्ये जोडलेली बिले मोजली जातात; ड्राफ्ट आणि रद्द केलेली बिले वगळली जातात.",
  "Only one sale runs at a time. Sales start and end by themselves at the times you set.": "एका वेळी एकच सेल चालतो. तुम्ही ठरवलेल्या वेळी सेल आपोआप सुरू होतात आणि संपतात.",
  "Only slow movers": "फक्त हळू विकणारे",
  "Open Google Authenticator and enter the 6-digit code for Devi Sarees.": "Google Authenticator उघडा आणि Devi Sarees चा 6 अंकी कोड टाका.",
  "Open Marathi typing": "मराठी टायपिंग उघडा",
  "Open menu": "मेनू उघडा",
  "Open the parcel and check each piece. The customer gets {p0} back either way.": "पार्सल उघडा आणि प्रत्येक नग तपासा. कसेही असले तरी ग्राहकाला {p0} परत मिळतात.",
  "Open the parcel and check each saree. Only good pieces go back on sale.": "पार्सल उघडा आणि प्रत्येक साडी तपासा. फक्त चांगले नग पुन्हा विक्रीला जातात.",
  "Opening video": "उघडतानाचा व्हिडिओ",
  "Order": "ऑर्डर",
  "Order cancelled": "ऑर्डर रद्द झाली",
  "Order cancelled.": "ऑर्डर रद्द झाली.",
  "Order cancelled. The refund has been sent to Razorpay.": "ऑर्डर रद्द झाली. परतावा Razorpay ला पाठवला आहे.",
  "Order confirmation email": "ऑर्डर निश्चितीचा ईमेल",
  "Order confirmed": "ऑर्डर निश्चित झाली",
  "Order placed": "ऑर्डर दिली",
  "Order progress": "ऑर्डरची प्रगती",
  "Order received email": "ऑर्डर मिळाल्याचा ईमेल",
  "Order {p0}": "ऑर्डर {p0}",
  "Order {p0} booked. Send the customer the payment link.": "ऑर्डर {p0} बुक झाली. ग्राहकाला पेमेंट लिंक पाठवा.",
  "Order {p0} packed.": "ऑर्डर {p0} पॅक झाली.",
  "Order {p0} packed. Print the label.": "ऑर्डर {p0} पॅक झाली. लेबल छापा.",
  "Order, phone, email or name": "ऑर्डर, फोन, ईमेल किंवा नाव",
  "Orders": "ऑर्डर",
  "Orders by where they are now": "ऑर्डर सध्या कुठे आहेत त्यानुसार",
  "Orders placed in the period": "या कालावधीत दिलेल्या ऑर्डर",
  "Other": "इतर",
  "Other size": "इतर आकार",
  "Other spellings of “{word}”:": "“{word}” ची इतर रूपे:",
  "Out for delivery": "डिलिव्हरीसाठी निघाले",
  "Out of stock": "स्टॉक संपला",
  "Outbox": "आउटबॉक्स",
  "Overview": "आढावा",
  "Owner": "मालक",
  "PIN code": "पिन कोड",
  "Pack": "पॅक करा",
  "Pack it again (back to the packing queue)": "पुन्हा पॅक करा (पॅकिंग रांगेत परत)",
  "Pack {p0}": "{p0} पॅक करा",
  "Packed": "पॅक झाले",
  "Packed weight (grams)": "पॅक केलेले वजन (ग्रॅम)",
  "Packed with": "यात पॅक केले",
  "Packed with {p0}, AWB {p1}. Stick the 4×6 label on the parcel, then book the pickup.": "{p0} सह पॅक झाले, AWB {p1}. पार्सलवर 4×6 लेबल लावा, मग पिकअप बुक करा.",
  "Packed, label ready": "पॅक झाले, लेबल तयार",
  "Packed, not picked up for a day": "पॅक झाले, एक दिवस पिकअप नाही",
  "Packing": "पॅकिंग",
  "Packing material": "पॅकिंग साहित्य",
  "Packing material, Shiprocket bills, ads, phone and internet, rent: add them as you pay.": "पॅकिंग साहित्य, Shiprocket बिले, जाहिराती, फोन आणि इंटरनेट, भाडे: पैसे देताच जोडा.",
  "Packing queue, shipments, labels and pickups.": "पॅकिंग रांग, शिपमेंट, लेबल आणि पिकअप.",
  "Packing started": "पॅकिंग सुरू झाले",
  "Packing stopped half-way (the courier didn't answer). Finish it; no second parcel is made.": "पॅकिंग अर्धवट थांबले (कुरिअरने उत्तर दिले नाही). ते पूर्ण करा; दुसरे पार्सल बनत नाही.",
  "Pages": "पाने",
  "Paid": "भरले",
  "Paid after the hold ran out, and the stock is gone. Refund the customer.": "होल्ड संपल्यानंतर पैसे भरले, आणि स्टॉक संपला आहे. ग्राहकाला पैसे परत करा.",
  "Paid after the order was cancelled. Refund the customer.": "ऑर्डर रद्द झाल्यानंतर पैसे भरले. ग्राहकाला पैसे परत करा.",
  "Paid by": "यांनी भरले",
  "Paid in this period:": "या कालावधीत भरले:",
  "Paid on": "भरल्याची तारीख",
  "Paid orders": "भरलेल्या ऑर्डर",
  "Paid orders appear here as soon as the payment is confirmed.": "पेमेंटची खात्री होताच भरलेल्या ऑर्डर इथे दिसतात.",
  "Paid orders waiting to be packed, oldest first. Pack each one, print its 4×6 label, then book the pickup from": "पॅक होण्याची वाट पाहणाऱ्या भरलेल्या ऑर्डर, जुन्या आधी. प्रत्येक पॅक करा, त्याचे 4×6 लेबल छापा, मग पिकअप बुक करा येथून:",
  "Paid to": "यांना दिले",
  "Paid {p0} · {p1}": "भरले {p0} · {p1}",
  "Parcel": "पार्सल",
  "Parcel and order cancelled; the refund has been sent.": "पार्सल आणि ऑर्डर रद्द; परतावा पाठवला आहे.",
  "Parcel arrived: inspect and refund": "पार्सल पोहोचले: तपासा आणि परतावा द्या",
  "Parcel back with us": "पार्सल आपल्याकडे परत",
  "Parcel cancelled. The order is back in the packing queue.": "पार्सल रद्द. ऑर्डर पुन्हा पॅकिंग रांगेत आहे.",
  "Parcels": "पार्सल",
  "Parcels appear here once orders are packed.": "ऑर्डर पॅक झाल्यावर पार्सल इथे दिसतात.",
  "Partly refunded": "अंशतः परतावा",
  "Password": "पासवर्ड",
  "Password saved.{p0}": "पासवर्ड जतन केला.{p0}",
  "Pay {p0} to the customer by UPI, then record the reference.": "ग्राहकाला UPI ने {p0} द्या, मग संदर्भ नोंदवा.",
  "Payment": "पेमेंट",
  "Payment failed": "पेमेंट अयशस्वी",
  "Payment gateway (other)": "पेमेंट गेटवे (इतर)",
  "Payment link": "पेमेंट लिंक",
  "Payment link copied.": "पेमेंट लिंक कॉपी झाली.",
  "Payment link created.": "पेमेंट लिंक तयार झाली.",
  "Payment link sent on WhatsApp.": "पेमेंट लिंक WhatsApp वर पाठवली.",
  "Payment received": "पेमेंट मिळाले",
  "Payment time ran out email": "पेमेंटची वेळ संपल्याचा ईमेल",
  "Payments and refunds": "पेमेंट आणि परतावे",
  "Pending payments": "बाकी पेमेंट",
  "Percent off (1–90)": "टक्के सूट (1–90)",
  "Percentage off": "टक्केवारी सूट",
  "Period": "कालावधी",
  "Permission": "परवानगी",
  "Person": "व्यक्ती",
  "Phone": "फोन",
  "Photos": "फोटो",
  "Pick list": "पिक लिस्ट",
  "Pick list ({p0} pieces)": "पिक लिस्ट ({p0} नग)",
  "Pick the pieces above, check them, pack them, then weigh the parcel.": "वरचे नग काढा, तपासा, पॅक करा, मग पार्सलचे वजन करा.",
  "Pickup booked": "पिकअप बुक झाले",
  "Pickup booked for {n} parcel{s}.": "{n} पार्सलसाठी पिकअप बुक झाले.",
  "Pickup booked on {p0}. Hand the parcel and the manifest to the courier.": "{p0} रोजी पिकअप बुक झाले. पार्सल आणि मॅनिफेस्ट कुरिअरकडे द्या.",
  "Pickup booked. The courier will collect it.": "पिकअप बुक झाले. कुरिअर ते घेऊन जाईल.",
  "Pieces": "नग",
  "Pieces and sales of {p0}": "{p0} चे नग आणि विक्री",
  "Pieces bought": "खरेदी केलेले नग",
  "Pieces in stock": "स्टॉकमधील नग",
  "Pieces of {p0} sold by colour": "{p0} चे रंगानुसार विकलेले नग",
  "Place of supply": "पुरवठ्याचे ठिकाण",
  "Placed": "दिली",
  "Plan a festival sale ahead of time and it will start by itself.": "सणाचा सेल आधीच ठरवा, तो आपोआप सुरू होईल.",
  "Previous": "मागील",
  "Previous page": "मागचे पान",
  "Price": "किंमत",
  "Prices go back to normal straight away. Orders already placed keep their sale prices.": "किमती लगेच नेहमीप्रमाणे होतात. आधी दिलेल्या ऑर्डरच्या सेल किमती तशाच राहतात.",
  "Prices in this sale": "या सेलमधील किमती",
  "Print label": "लेबल छापा",
  "Problem resolved": "अडचण सुटली",
  "Product": "उत्पादन",
  "Product code": "उत्पादन कोड",
  "Product performance": "उत्पादनांची कामगिरी",
  "Products": "उत्पादने",
  "Profit": "नफा",
  "Profit margin": "नफ्याचे मार्जिन",
  "Profit report for {p0}": "{p0} चा नफ्याचा रिपोर्ट",
  "Profit report, figure by figure": "नफ्याचा रिपोर्ट, आकड्यानुसार",
  "Profit {p0}": "नफा {p0}",
  "Publish": "प्रकाशित करा",
  "Published: customers can see it now.": "प्रकाशित: ग्राहकांना आता दिसते.",
  "Puducherry": "पुदुच्चेरी",
  "Punjab": "पंजाब",
  "Purchase": "खरेदी",
  "Purchase received": "खरेदी मिळाली",
  "Purchase voided": "खरेदी रद्द केली",
  "Purchase voided and its stock removed.": "खरेदी रद्द केली आणि तिचा स्टॉक काढला.",
  "Purchases": "खरेदी",
  "Purchases add stock here.": "खरेदीने इथे स्टॉक वाढतो.",
  "Purchases and the sales of what you bought appear here.": "खरेदी आणि तुम्ही घेतलेल्या मालाची विक्री इथे दिसते.",
  "Purchases by supplier": "पुरवठादारानुसार खरेदी",
  "Pure silk": "शुद्ध सिल्क",
  "Put in": "घातले",
  "Put in the field": "फील्डमध्ये टाका",
  "QR code for Google Authenticator": "Google Authenticator साठी QR कोड",
  "Rajasthan": "राजस्थान",
  "Rate": "दर",
  "Razorpay fees": "Razorpay शुल्क",
  "Reactivate": "पुन्हा सक्रिय करा",
  "Reactivate staff member": "स्टाफ सदस्य पुन्हा सक्रिय करा",
  "Reactivated staff": "स्टाफ पुन्हा सक्रिय केला",
  "Read": "पाहणे",
  "Ready to publish": "प्रकाशित करण्यास तयार",
  "Reason": "कारण",
  "Receipt": "पावती",
  "Receipt photo": "पावतीचा फोटो",
  "Received": "मिळाले",
  "Recipient name": "प्राप्तकर्त्याचे नाव",
  "Recipient phone": "प्राप्तकर्त्याचा फोन",
  "Record": "नोंदवा",
  "Record a purchase": "खरेदी नोंदवा",
  "Record a purchase to add stock.": "स्टॉक जोडण्यासाठी खरेदी नोंदवा.",
  "Record a salary": "पगार नोंदवा",
  "Record courier cost reimbursement": "कुरिअर खर्चाची परतफेड नोंदवा",
  "Record each salary when you pay it.": "प्रत्येक पगार देताच नोंदवा.",
  "Record purchase": "खरेदी नोंदवा",
  "Record returned parcel": "परत आलेले पार्सल नोंदवा",
  "Record salary": "पगार नोंदवा",
  "Record the bill when you bring stock home.": "माल घरी आणल्यावर बिल नोंदवा.",
  "Record the money you put into the business, what you take out, and equipment you buy.": "तुम्ही व्यवसायात घातलेले पैसे, काढलेले पैसे आणि खरेदी केलेली उपकरणे नोंदवा.",
  "Record the returned parcel": "परत आलेले पार्सल नोंदवा",
  "Recorded in the audit log": "ऑडिट लॉगमध्ये नोंदवले",
  "Recorded. Reimburse the courier cost by UPI when it arrives.": "नोंदवले. पार्सल पोहोचल्यावर कुरिअर खर्च UPI ने परत द्या.",
  "Refund": "परतावा",
  "Refund email": "परताव्याचा ईमेल",
  "Refund for these pieces:": "या नगांसाठी परतावा:",
  "Refund in progress": "परतावा सुरू आहे",
  "Refund of {p0} sent.": "{p0} चा परतावा पाठवला.",
  "Refund sent": "परतावा पाठवला",
  "Refund sent to Razorpay.": "परतावा Razorpay ला पाठवला.",
  "Refund started": "परतावा सुरू केला",
  "Refunded": "परतावा दिला",
  "Refunds paid": "दिलेले परतावे",
  "Registered customers": "नोंदणीकृत ग्राहक",
  "Regular": "नेहमीची",
  "Regular price": "नेहमीची किंमत",
  "Reimbursement recorded.": "परतफेड नोंदवली.",
  "Reject": "नाकारा",
  "Reject this return": "हा परतावा नाकारा",
  "Rejected": "नाकारले",
  "Remove": "काढा",
  "Remove pieces (lost, sold elsewhere)": "नग काढा (हरवलेले, इतरत्र विकलेले)",
  "Remove this colour": "हा रंग काढा",
  "Rent and utilities": "भाडे आणि वीज-पाणी",
  "Replace": "बदला",
  "Replace banner": "बॅनर बदला",
  "Report": "रिपोर्ट",
  "Report check by report": "रिपोर्टनुसार तपासणी",
  "Reported": "रिपोर्टमध्ये",
  "Reports": "रिपोर्ट",
  "Request": "विनंती",
  "Requested": "मागितले",
  "Reserved": "राखीव",
  "Reset": "रीसेट",
  "Reset Google Authenticator": "Google Authenticator रीसेट करा",
  "Reset authenticator": "Authenticator रीसेट करा",
  "Reset your password": "तुमचा पासवर्ड रीसेट करा",
  "Retry": "पुन्हा प्रयत्न करा",
  "Return": "परत",
  "Return approved email": "परतावा मंजूर झाल्याचा ईमेल",
  "Return approved. Book the pickup next.": "परतावा मंजूर. पुढे पिकअप बुक करा.",
  "Return not accepted email": "परतावा स्वीकारला नसल्याचा ईमेल",
  "Return or order number, name, phone": "परतावा किंवा ऑर्डर क्रमांक, नाव, फोन",
  "Return rate": "परतीचे प्रमाण",
  "Return received email": "परतावा मिळाल्याचा ईमेल",
  "Return rejected; the customer has been told why.": "परतावा नाकारला; ग्राहकाला कारण कळवले आहे.",
  "Return request received email": "परताव्याची विनंती मिळाल्याचा ईमेल",
  "Return requests from customers appear here.": "ग्राहकांच्या परताव्याच्या विनंत्या इथे दिसतात.",
  "Return shipping": "परतीचे शिपिंग",
  "Return shipping (self-ship)": "परतीचे शिपिंग (स्वतः पाठवलेले)",
  "Return shipping reimbursed email": "परतीच्या शिपिंगची परतफेड ईमेल",
  "Return update": "परताव्याची माहिती",
  "Return {p0}": "परतावा {p0}",
  "Returned": "परत आले",
  "Returned parcel received": "परत आलेले पार्सल मिळाले",
  "Returned parcel recorded.": "परत आलेले पार्सल नोंदवले.",
  "Returned to us": "आपल्याकडे परत आले",
  "Returns": "परतावे",
  "Returns requested in the period, by where they are now": "या कालावधीत मागितलेले परतावे, सध्या कुठे आहेत त्यानुसार",
  "Revenue": "उत्पन्न",
  "Revenue, profit and orders over the period": "कालावधीतील उत्पन्न, नफा आणि ऑर्डर",
  "Reverse pickup booked.": "रिव्हर्स पिकअप बुक झाले.",
  "Reverse pickup · {p0} · AWB": "रिव्हर्स पिकअप · {p0} · AWB",
  "Review return requests and videos, record inspections.": "परताव्याच्या विनंत्या आणि व्हिडिओ तपासणे, तपासणी नोंदवणे.",
  "Role": "भूमिका",
  "Roles": "भूमिका",
  "Roles for {p0}": "{p0} च्या भूमिका",
  "Roles updated for {p0}.": "{p0} च्या भूमिका बदलल्या.",
  "Rows": "ओळी",
  "Ruby red": "रुबी लाल",
  "Ruby red saree draped, gold zari border": "नेसलेली रुबी लाल साडी, सोनेरी जरी काठ",
  "SALE events": "SALE",
  "SKU (optional)": "SKU (ऐच्छिक)",
  "SKU, code, product or reason": "SKU, कोड, उत्पादन किंवा कारण",
  "Salaries": "पगार",
  "Salary for": "पगार कोणासाठी",
  "Salary payment deleted.": "पगार पेमेंट हटवले.",
  "Salary saved.": "पगार जतन केला.",
  "Sale": "सेल",
  "Sale covers": "सेलमध्ये समाविष्ट",
  "Sale discount": "सेल सवलत",
  "Sale name": "सेलचे नाव",
  "Sale price (₹)": "सेल किंमत (₹)",
  "Sale price {p0}": "सेल किंमत {p0}",
  "Sale saved.": "सेल जतन केला.",
  "Sale scheduled. It starts by itself.": "सेल ठरवला. तो आपोआप सुरू होईल.",
  "Sales": "विक्री",
  "Sales and stock show here.": "विक्री आणि स्टॉक इथे दिसतात.",
  "Sales before GST": "GST पूर्वी विक्री",
  "Sales trend for one saree": "एका साडीचा विक्री कल",
  "Sales trend, by day": "विक्री कल, दिवसानुसार",
  "Sales trend, by month": "विक्री कल, महिन्यानुसार",
  "Sales, margin and returns count the colours each supplier last sold you. Margin is before GST.": "विक्री, मार्जिन आणि परतावे प्रत्येक पुरवठादाराने शेवटचे विकलेल्या रंगांनुसार मोजले जातात. मार्जिन GST पूर्वी आहे.",
  "Saree": "साडी",
  "Saree box": "साडी बॉक्स",
  "Saree length (m)": "साडीची लांबी (मी)",
  "Saree purchases": "साडी खरेदी",
  "Sarees": "साड्या",
  "Sarees and blouses": "साड्या आणि ब्लाउज",
  "Save": "जतन करा",
  "Save and add to the bill": "जतन करा आणि बिलात जोडा",
  "Save and change address": "जतन करा आणि पत्ता बदला",
  "Save and refund": "जतन करा आणि परतावा द्या",
  "Save change": "बदल जतन करा",
  "Save changes": "बदल जतन करा",
  "Save colour": "रंग जतन करा",
  "Save details": "तपशील जतन करा",
  "Save draft": "ड्राफ्ट जतन करा",
  "Save expense": "खर्च जतन करा",
  "Save new password": "नवीन पासवर्ड जतन करा",
  "Save rate": "दर जतन करा",
  "Save roles": "भूमिका जतन करा",
  "Save supplier": "पुरवठादार जतन करा",
  "Save your backup codes": "तुमचे बॅकअप कोड जतन करा",
  "Saved": "जतन केले",
  "Saved.": "जतन केले.",
  "Say what you did, for the record.": "नोंदीसाठी तुम्ही काय केले ते लिहा.",
  "Schedule": "ठरवा",
  "Schedule sale": "सेल ठरवा",
  "Schedule this sale?": "हा सेल ठरवायचा?",
  "Search": "शोधा",
  "Search engine listing": "सर्च इंजिनवरील माहिती",
  "Select option...": "पर्याय निवडा...",
  "Sell-through": "सेल-थ्रू",
  "Sellable": "विकण्याजोगे",
  "Seller’s GSTIN (optional)": "विक्रेत्याचा GSTIN (ऐच्छिक)",
  "Selling price (₹)": "विक्री किंमत (₹)",
  "Send automatically": "आपोआप पाठवा",
  "Send invite": "आमंत्रण पाठवा",
  "Send on WhatsApp": "WhatsApp वर पाठवा",
  "Send reset link": "रीसेट लिंक पाठवा",
  "Send to courier": "कुरिअरला पाठवा",
  "Sent": "पाठवले",
  "Sent for another try.": "पुन्हा प्रयत्नासाठी पाठवले.",
  "Sent to WhatsApp": "WhatsApp वर पाठवले",
  "Set password": "पासवर्ड सेट करा",
  "Set up Google Authenticator": "Google Authenticator सेट करा",
  "Set your password": "तुमचा पासवर्ड सेट करा",
  "Shipped": "पाठवले",
  "Shipped email": "पाठवल्याचा ईमेल",
  "Shipping": "शिपिंग",
  "Shipping (Shiprocket)": "शिपिंग (Shiprocket)",
  "Show": "दाखवा",
  "Show a countdown on the home-page banner": "होम पेज बॅनरवर काउंटडाउन दाखवा",
  "Show everything": "सर्व दाखवा",
  "Show on the storefront": "स्टोअरफ्रंटवर दाखवा",
  "Show this colour": "हा रंग दाखवा",
  "Showing": "दाखवत आहे",
  "Showing page": "दाखवलेले पान",
  "Shown struck through. Must be higher than the price.": "काट मारून दाखवली जाते. किमतीपेक्षा जास्त असली पाहिजे.",
  "Shown when customers choose Marathi.": "ग्राहक मराठी निवडतात तेव्हा दिसते.",
  "Shows colour": "रंग दाखवतो",
  "Sign in": "साइन इन करा",
  "Sign out": "साइन आउट करा",
  "Signed in": "साइन इन केले",
  "Signed in as {p0}.": "{p0} म्हणून साइन इन केले.",
  "Sikkim": "सिक्कीम",
  "Since": "पासून",
  "Size": "आकार",
  "Sleeve": "बाही",
  "Sold": "विकले",
  "Some of these pieces have already been sold or adjusted, so the purchase can no longer be voided.": "यातील काही नग आधीच विकले किंवा बदलले गेले आहेत, त्यामुळे ही खरेदी आता रद्द करता येत नाही.",
  "Something went wrong.": "काहीतरी चुकले.",
  "Something went wrong. Please try again.": "काहीतरी चुकले. कृपया पुन्हा प्रयत्न करा.",
  "Spend": "खर्च",
  "Spend and sales by supplier": "पुरवठादारानुसार खर्च आणि विक्री",
  "Staff": "स्टाफ",
  "Staff accounts need a code from your phone at every sign-in.": "स्टाफ खात्यांना प्रत्येक साइन इनला फोनवरील कोड लागतो.",
  "Staff only. Sign-ins are recorded.": "फक्त स्टाफसाठी. साइन इनची नोंद ठेवली जाते.",
  "Staff with this role get the new permissions straight away.": "या भूमिकेच्या स्टाफला नवीन परवानग्या लगेच मिळतात.",
  "Start now": "आताच सुरू करा",
  "Starting capital": "सुरुवातीचे भांडवल",
  "Starts": "सुरू होतो",
  "Starts (India time)": "सुरू होतो (भारतीय वेळ)",
  "Starts by itself on {p0}.": "{p0} रोजी आपोआप सुरू होतो.",
  "State": "राज्य",
  "Status": "स्थिती",
  "Steps the shop refused": "दुकानाने नाकारलेल्या पायऱ्या",
  "Still buying from them": "अजून त्यांच्याकडून खरेदी चालू",
  "Stitched blouse": "शिवलेला ब्लाउज",
  "Stock": "स्टॉक",
  "Stock added": "स्टॉक जोडला",
  "Stock added: {p0} pieces.": "स्टॉक जोडला: {p0} नग.",
  "Stock history": "स्टॉक इतिहास",
  "Stock updated for {p0}.": "{p0} चा स्टॉक बदलला.",
  "Stock value": "स्टॉकचे मूल्य",
  "Stock value by colour": "रंगानुसार स्टॉकचे मूल्य",
  "Style": "शैली",
  "Sub-categories are included.": "उप-श्रेणी समाविष्ट आहेत.",
  "Sunita": "सुनीता",
  "Supplier": "पुरवठादार",
  "Supplier or GSTIN": "पुरवठादार किंवा GSTIN",
  "Supplier performance": "पुरवठादारांची कामगिरी",
  "Supplier saved.": "पुरवठादार जतन केला.",
  "Suppliers": "पुरवठादार",
  "Suspend": "निलंबित करा",
  "Suspend staff member": "स्टाफ सदस्य निलंबित करा",
  "Suspended": "निलंबित",
  "Suspended staff": "स्टाफ निलंबित केला",
  "Swatch": "रंगाचा नमुना",
  "System": "सिस्टम",
  "Table": "तक्ता",
  "Taken out": "काढले",
  "Tamil Nadu": "तमिळनाडू",
  "Tax": "कर",
  "Taxable": "करपात्र",
  "Taxable value": "करपात्र मूल्य",
  "Team": "टीम",
  "Telangana": "तेलंगणा",
  "Test data": "चाचणी डेटा",
  "Test data is loaded": "चाचणी डेटा लोड केला आहे",
  "Test data run failed.": "चाचणी डेटा लोड अयशस्वी झाला.",
  "Test data run finished.": "चाचणी डेटा लोड पूर्ण झाला.",
  "Text": "मजकूर",
  "The AWB is cancelled at Shiprocket. Then:": "Shiprocket वर AWB रद्द झाला आहे. मग:",
  "The amount paid differs from the order total. Check with Razorpay.": "भरलेली रक्कम ऑर्डरच्या एकूण रकमेपेक्षा वेगळी आहे. Razorpay कडे तपासा.",
  "The claim": "दावा",
  "The courier could not deliver. Ask for another attempt or have it returned.": "कुरिअर पोहोचवू शकले नाही. पुन्हा प्रयत्न करायला सांगा किंवा परत मागवा.",
  "The courier could not pick up the parcel. Check with Shiprocket.": "कुरिअर पार्सल घेऊ शकले नाही. Shiprocket कडे तपासा.",
  "The courier reports the parcel damaged. Contact Shiprocket.": "कुरिअरनुसार पार्सल खराब झाले. Shiprocket शी संपर्क करा.",
  "The courier reports the parcel destroyed. Contact Shiprocket.": "कुरिअरनुसार पार्सल नष्ट झाले. Shiprocket शी संपर्क करा.",
  "The courier reports the parcel lost. Contact Shiprocket.": "कुरिअरनुसार पार्सल हरवले. Shiprocket शी संपर्क करा.",
  "The courier will return it.": "कुरिअर ते परत पाठवेल.",
  "The courier will try again.": "कुरिअर पुन्हा प्रयत्न करेल.",
  "The customer agreed to order updates on WhatsApp": "ग्राहकाने WhatsApp वर ऑर्डरची माहिती घेण्यास संमती दिली",
  "The customer asked for WhatsApp updates. None sent yet.": "ग्राहकाने WhatsApp वर माहिती मागितली. अजून काही पाठवलेले नाही.",
  "The customer didn't ask for WhatsApp updates on this order. They get emails.": "ग्राहकाने या ऑर्डरसाठी WhatsApp वर माहिती मागितली नाही. त्यांना ईमेल मिळतात.",
  "The customer is emailed this reason. Nothing is picked up.": "ग्राहकाला हे कारण ईमेलने कळवले जाते. काहीही घेऊन जात नाहीत.",
  "The customer is sending it · AWB {p0} · courier cost {p1}": "ग्राहक पाठवत आहे · AWB {p0} · कुरिअर खर्च {p1}",
  "The customer paid twice. Refund the second payment.": "ग्राहकाने दोनदा पैसे भरले. दुसऱ्या पेमेंटचा परतावा द्या.",
  "The last run stopped: {p0}": "शेवटचा प्रयत्न थांबला: {p0}",
  "The parcel is coming back to you undelivered.": "पार्सल न पोहोचता तुमच्याकडे परत येत आहे.",
  "The payment link couldn't be created (Razorpay didn't answer).": "पेमेंट लिंक तयार झाली नाही (Razorpay ने उत्तर दिले नाही).",
  "The returned parcel has been checked. Decide the refund, then mark this resolved.": "परत आलेले पार्सल तपासले आहे. परताव्याचा निर्णय घ्या, मग सोडवले म्हणून नोंदवा.",
  "The sale has ended.": "सेल संपला आहे.",
  "The sale is live.": "सेल चालू आहे.",
  "The stock goes back on sale and {p0} is refunded to the customer.": "स्टॉक पुन्हा विक्रीला जातो आणि ग्राहकाला {p0} परत केले जातात.",
  "The stock goes back on sale.": "स्टॉक पुन्हा विक्रीला जातो.",
  "The stock is held until {p0}. If it isn't paid by then, the order is cancelled and the stock goes back on sale.": "{p0} पर्यंत स्टॉक राखून ठेवला आहे. तोपर्यंत पैसे न भरल्यास ऑर्डर रद्द होते आणि स्टॉक पुन्हा विक्रीला जातो.",
  "The undelivered parcel is back. Open it, check the sarees and record what you found.": "न पोहोचलेले पार्सल परत आले आहे. ते उघडा, साड्या तपासा आणि काय आढळले ते नोंदवा.",
  "Their courier and AWB": "त्यांचे कुरिअर आणि AWB",
  "Theme": "थीम",
  "Theme: {name}": "थीम: {name}",
  "There are no records to display": "दाखवण्यासाठी नोंदी नाहीत",
  "There are not enough pieces for that change.": "त्या बदलासाठी पुरेसे नग नाहीत.",
  "They'll get an email to set a password (valid 72 hours), then set up Google Authenticator at first sign-in.": "त्यांना पासवर्ड सेट करण्यासाठी ईमेल येईल (72 तास चालतो), मग पहिल्या साइन इनला ते Google Authenticator सेट करतील.",
  "This adds": "यामुळे",
  "This adds about a year of made-up sarees, customers, orders, invoices, purchases and expenses. Every list and report will include them until you delete them. It takes about 2–5 minutes.": "यामुळे सुमारे एका वर्षाच्या काल्पनिक साड्या, ग्राहक, ऑर्डर, इनव्हॉइस, खरेदी आणि खर्च जोडले जातात. तुम्ही ते हटवेपर्यंत प्रत्येक यादी आणि रिपोर्टमध्ये ते असतील. सुमारे 2–5 मिनिटे लागतात.",
  "This change needs your password and a fresh code from Google Authenticator. You won't be asked again for 15 minutes.": "या बदलासाठी तुमचा पासवर्ड आणि Google Authenticator चा नवीन कोड लागतो. 15 मिनिटे पुन्हा विचारले जाणार नाही.",
  "This financial year": "हे आर्थिक वर्ष",
  "This link is incomplete. Open it again from your email.": "ही लिंक अपूर्ण आहे. ती तुमच्या ईमेलमधून पुन्हा उघडा.",
  "This month": "हा महिना",
  "This product is live. Changing its address breaks links you've already shared on Instagram or WhatsApp.": "हे उत्पादन चालू आहे. त्याचा पत्ता बदलल्यास Instagram किंवा WhatsApp वर आधी शेअर केलेल्या लिंक तुटतात.",
  "This week": "हा आठवडा",
  "This year": "हे वर्ष",
  "Timeline": "घटनाक्रम",
  "Times are India time. Entries can't be edited or deleted.": "वेळा भारतीय वेळेनुसार आहेत. नोंदी बदलता किंवा हटवता येत नाहीत.",
  "Title": "शीर्षक",
  "To": "पर्यंत",
  "To review": "तपासायचे",
  "Top level": "मुख्य स्तर",
  "Total": "एकूण",
  "Total (GST included)": "एकूण (GST सह)",
  "Total expenses": "एकूण खर्च",
  "Tripura": "त्रिपुरा",
  "Try another filter, or invite someone.": "दुसरा फिल्टर वापरा, किंवा कोणाला तरी आमंत्रित करा.",
  "Turn on and sign in": "सुरू करा आणि साइन इन करा",
  "Type": "प्रकार",
  "Type (like order.shipped) or error": "प्रकार (जसे order.shipped) किंवा त्रुटी",
  "Type Marathi with English letters": "इंग्रजी अक्षरांनी मराठी टाइप करा",
  "Type a code (like AK102) or a name": "कोड (जसे AK102) किंवा नाव टाका",
  "Type a code (like AK102), a name or a SKU": "कोड (जसे AK102), नाव किंवा SKU टाका",
  "Type a code or a name above to see how that saree sold in this period.": "या कालावधीत ती साडी कशी विकली गेली हे पाहण्यासाठी वर कोड किंवा नाव टाका.",
  "Type a product name or SKU": "उत्पादनाचे नाव किंवा SKU टाका",
  "Type in English, like namaskar, and press space": "इंग्रजीत टाइप करा, जसे namaskar, आणि स्पेस दाबा",
  "Type in Marathi": "मराठीत टाइप करा",
  "UPI reference": "UPI संदर्भ",
  "Undelivered (RTO)": "न पोहोचलेले (RTO)",
  "Undelivered emails and tasks": "न पोहोचलेले ईमेल आणि कामे",
  "Unpublish": "प्रकाशन थांबवा",
  "Unstitched blouse fabric": "न शिवलेले ब्लाउज कापड",
  "Up to 70 characters. Defaults to the name.": "जास्तीत जास्त 70 अक्षरे. रिकामे असल्यास नाव वापरले जाते.",
  "Up to {p0} can be refunded, back to the customer's original payment method.": "जास्तीत जास्त {p0} परत करता येतात, ग्राहकाच्या मूळ पेमेंट पद्धतीवर.",
  "Upcoming": "येणारा",
  "Updated": "बदलले",
  "Upload banner": "बॅनर अपलोड करा",
  "Upload photos": "फोटो अपलोड करा",
  "Use a backup code": "बॅकअप कोड वापरा",
  "Use the admin in English": "ॲडमिन इंग्रजीत वापरा",
  "Use the admin in Marathi": "ॲडमिन मराठीत वापरा",
  "Use the authenticator app": "authenticator ॲप वापरा",
  "Use this when reverse pickup isn't available at their PIN code. You'll reimburse the full courier cost by UPI.": "त्यांच्या पिन कोडवर रिव्हर्स पिकअप उपलब्ध नसल्यास हे वापरा. तुम्ही कुरिअरचा पूर्ण खर्च UPI ने परत द्याल.",
  "Use your staff email and password.": "तुमचा स्टाफ ईमेल आणि पासवर्ड वापरा.",
  "Used a backup code": "बॅकअप कोड वापरला",
  "Uttar Pradesh": "उत्तर प्रदेश",
  "Uttarakhand": "उत्तराखंड",
  "Value": "मूल्य",
  "View": "पाहा",
  "View purchase": "खरेदी पाहा",
  "Viewed a customer": "ग्राहकाची माहिती पाहिली",
  "Visitors in the last 15 minutes": "मागील 15 मिनिटांतील अभ्यागत",
  "Void": "रद्द करा",
  "Void purchase": "खरेदी रद्द करा",
  "Void this purchase": "ही खरेदी रद्द करा",
  "Voided": "रद्द केली",
  "Voided {p0}: “{p1}”": "{p0} रोजी रद्द केली: “{p1}”",
  "Waiting for payment": "पेमेंटची वाट",
  "Waiting for the courier to collect it": "कुरिअर घेऊन जाण्याची वाट",
  "Waiting to be sent": "पाठवण्याची वाट",
  "Waiting to send": "पाठवण्याची वाट",
  "Was {p0}": "आधी {p0}",
  "We'll email you a link to choose a new password.": "नवीन पासवर्ड निवडण्यासाठी आम्ही तुम्हाला लिंक ईमेल करू.",
  "Weave": "विणकाम",
  "Web address": "वेब पत्ता",
  "Website": "वेबसाइट",
  "Website orders appear here, and orders you book for WhatsApp or Instagram customers.": "वेबसाइटवरील ऑर्डर इथे दिसतात, आणि WhatsApp किंवा Instagram ग्राहकांसाठी तुम्ही बुक केलेल्या ऑर्डरही.",
  "Website orders paid": "वेबसाइटवरील भरलेल्या ऑर्डर",
  "Wedding": "लग्न",
  "Weight (g)": "वजन (ग्रॅम)",
  "Welcome. Choose a password for {p0}.": "स्वागत आहे. {p0} साठी पासवर्ड निवडा.",
  "West Bengal": "पश्चिम बंगाल",
  "What": "काय",
  "What did you buy?": "तुम्ही काय खरेदी केले?",
  "What each role can do. The owner role always has everything. Changes apply at the staff member's next request.": "प्रत्येक भूमिका काय करू शकते. मालकाच्या भूमिकेला नेहमी सर्व काही असते. बदल स्टाफ सदस्याच्या पुढच्या विनंतीपासून लागू होतात.",
  "What for": "कशासाठी",
  "What for, or seller GSTIN": "कशासाठी, किंवा विक्रेत्याचा GSTIN",
  "What it loaded so far can be deleted with the button above.": "आतापर्यंत लोड झालेले वरच्या बटणाने हटवता येते.",
  "What the report shows": "रिपोर्टमध्ये काय दिसते",
  "What the test data did": "चाचणी डेटाने काय केले",
  "What to do next": "पुढे काय करायचे",
  "What was loaded": "काय लोड झाले",
  "What you bought": "तुम्ही काय खरेदी केले",
  "What you found": "तुम्हाला काय आढळले",
  "What's included": "काय समाविष्ट आहे",
  "WhatsApp number": "WhatsApp क्रमांक",
  "WhatsApp updates": "WhatsApp माहिती",
  "When": "केव्हा",
  "Where": "कुठे",
  "Where the money went": "पैसे कुठे गेले",
  "Whole store": "संपूर्ण दुकान",
  "With the courier": "कुरिअरकडे",
  "With the courier over 7 days": "7 दिवसांपेक्षा जास्त कुरिअरकडे",
  "Working…": "काम सुरू आहे…",
  "Works without internet. Ctrl+G switches between Marathi and English.": "इंटरनेटशिवाय चालते. Ctrl+G ने मराठी आणि इंग्रजी बदला.",
  "Write off damaged pieces": "खराब नग काढून टाका",
  "Wrong authenticator code": "चुकीचा authenticator कोड",
  "You can also book one pickup for all packed parcels on the Parcels screen.": "पार्सल स्क्रीनवर सर्व पॅक केलेल्या पार्सलसाठी एकच पिकअप बुक करू शकता.",
  "You were signed out. Please sign in again.": "तुम्ही साइन आउट झालात. कृपया पुन्हा साइन इन करा.",
  "Zari pulled on the pallu, found while packing": "पदरावरील जरी ओढली गेली, पॅकिंग करताना आढळले",
  "a deleted user": "हटवलेला वापरकर्ता",
  "after expenses and salaries": "खर्च आणि पगारानंतर",
  "after the cost of sarees sold": "विकलेल्या साड्यांच्या खर्चानंतर",
  "at purchase cost, without GST": "खरेदी किमतीवर, GST शिवाय",
  "before GST, after refunds": "GST पूर्वी, परताव्यानंतर",
  "by {p0}": "{p0} कडून",
  "cost missing": "खर्च नाही",
  "done": "पूर्ण",
  "missing: add HSN codes to these products": "नाही: या उत्पादनांना HSN कोड जोडा",
  "never": "कधीच नाही",
  "next": "पुढचे",
  "no cost": "खर्च नाही",
  "no phone": "फोन नाही",
  "of": "/",
  "one colour": "एक रंग",
  "order": "ऑर्डर",
  "price minus cost with GST: {p0}": "किंमत वजा GST सह खर्च: {p0}",
  "to stock and locks the bill ({p0}). Customers waiting for these colours are emailed.": "स्टॉकमध्ये जोडले जातात आणि बिल लॉक होते ({p0}). या रंगांची वाट पाहणाऱ्या ग्राहकांना ईमेल जातो.",
  "your account": "तुमचे खाते",
  "{from}–{to} of {total}": "{total} पैकी {from}–{to}",
  "{n} photo{s} added. Add a description to each.": "{n} फोटो जोडले. प्रत्येकाला वर्णन जोडा.",
  "{p0} (IGST {p1})": "{p0} (IGST {p1})",
  "{p0} added to the bill. Enter the pieces and cost of each.": "{p0} बिलात जोडले. प्रत्येकाचे नग आणि खर्च टाका.",
  "{p0} available": "{p0} उपलब्ध",
  "{p0} available, {p1} damaged. Changes are recorded in the stock history with your reason.": "{p0} उपलब्ध, {p1} खराब. बदल तुमच्या कारणासह स्टॉक इतिहासात नोंदवले जातात.",
  "{p0} can sign in again.": "{p0} पुन्हा साइन इन करू शकतात.",
  "{p0} colours": "{p0} रंग",
  "{p0} colour{p1} below keep their regular price: the discount wouldn't lower it.": "खालील {p0} रंगांची नेहमीचीच किंमत राहते: सवलतीने ती कमी होणार नाही.",
  "{p0} colour{p1} stock but no purchase cost, so {p2} counted in the value.": "{p0} रंगांचा स्टॉक आहे पण खरेदी किंमत नाही, त्यामुळे ते मूल्यात मोजलेले नाहीत.",
  "{p0} damaged": "{p0} खराब",
  "{p0} days ago": "{p0} दिवसांपूर्वी",
  "{p0} deleted.": "{p0} हटवले.",
  "{p0} delivered in the period": "या कालावधीत {p0} पोहोचले",
  "{p0} is suspended.": "{p0} निलंबित केले.",
  "{p0} line{p1}": "{p0} ओळी",
  "{p0} new": "{p0} नवीन",
  "{p0} of payments went through": "{p0} पेमेंट यशस्वी झाले",
  "{p0} of {p1}": "{p1} पैकी {p0}",
  "{p0} of {p1} figures differ": "{p1} पैकी {p0} आकड्यांमध्ये फरक",
  "{p0} on the website · {p1} booked by you": "वेबसाइटवर {p0} · तुम्ही बुक केलेल्या {p1}",
  "{p0} orders": "{p0} ऑर्डर",
  "{p0} orders waiting · {p1} payment links open": "{p0} ऑर्डर वाट पाहत आहेत · {p1} पेमेंट लिंक उघड्या",
  "{p0} paid orders, GST included": "{p0} भरलेल्या ऑर्डर, GST सह",
  "{p0} permissions saved.": "{p0} परवानग्या जतन केल्या.",
  "{p0} pieces": "{p0} नग",
  "{p0} pieces · {p1}": "{p0} नग · {p1}",
  "{p0} piece{p1}": "{p0} नग",
  "{p0} piece{p1} sold in this period had no purchase cost recorded, so the cost of sarees sold is too low. Record purchases for every colour.": "या कालावधीत विकलेल्या {p0} नगांची खरेदी किंमत नोंदवलेली नव्हती, त्यामुळे विकलेल्या साड्यांचा खर्च कमी दिसतो. प्रत्येक रंगाची खरेदी नोंदवा.",
  "{p0} returns": "{p0} परतावे",
  "{p0} to {p1}": "{p0} ते {p1}",
  "{p0} waiting": "{p0} वाट पाहत आहेत",
  "{p0} will be able to sign in again.": "{p0} पुन्हा साइन इन करू शकतील.",
  "{p0} will be signed out everywhere and can't sign in until reactivated.": "{p0} सगळीकडून साइन आउट होतील आणि पुन्हा सक्रिय होईपर्यंत साइन इन करू शकणार नाहीत.",
  "{p0} will set up Google Authenticator again at their next sign-in. Use this when they lose their phone.": "{p0} पुढच्या साइन इनला Google Authenticator पुन्हा सेट करतील. त्यांचा फोन हरवल्यास हे वापरा.",
  "{p0} will set up Google Authenticator again.": "{p0} Google Authenticator पुन्हा सेट करतील.",
  "{p0} with GST": "GST सह {p0}",
  "{p0} · AWB": "{p0} · AWB",
  "{p0} · against {p1} · {p2}": "{p0} · {p1} विरुद्ध · {p2}",
  "{p0} · {p1} colour{p2}": "{p0} · {p1} रंग",
  "{p0} · {p1} · {p2} days{p3}": "{p0} · {p1} · {p2} दिवस{p3}",
  "{p0}, {p1} on {p2}. The audit log keeps a record.": "{p0}, {p2} रोजी {p1}. ऑडिट लॉगमध्ये नोंद राहते.",
  "{p0}, {p1} paid on {p2}. The audit log keeps a record.": "{p0}, {p2} रोजी {p1} दिले. ऑडिट लॉगमध्ये नोंद राहते.",
  "{p0}, {p1}. The audit log keeps a record.": "{p0}, {p1}. ऑडिट लॉगमध्ये नोंद राहते.",
  "· expected {p0}": "· अपेक्षित {p0}",
  "· {p0} available": "· {p0} उपलब्ध",
  "· {p0} · {p1} pieces · {p2}": "· {p0} · {p1} नग · {p2}"
}